import { object, array, string } from '@gogame/schemas';

import {
  COLUMN_ID,
  COLUMN_NAME,
  COLUMN_STATUS,
  COLUMN_PARTNER_COMPANY,
  COLUMN_BUSINESS_PARTNER,
  COLUMN_NETWORK,
  COLUMN_TRAFFIC_TYPES,
  COLUMN_EXPENSE_TYPE,
  COLUMN_OWNER,
  COLUMN_CREATED_BY,
  COLUMN_UPDATED_DATE,
  COLUMN_CHANNEL,
  COLUMN_CREATED_DATE,
  COLUMN_ADDITIONAL_FEE,
} from 'scenes/Affiliates/constants';

export const columnsSchema = object({
  order: array(string()).default([
    COLUMN_ID,
    COLUMN_NAME,
    COLUMN_STATUS,
    COLUMN_PARTNER_COMPANY,
    COLUMN_BUSINESS_PARTNER,
    COLUMN_NETWORK,
    COLUMN_CHANNEL,
    COLUMN_TRAFFIC_TYPES,
    COLUMN_EXPENSE_TYPE,
    COLUMN_ADDITIONAL_FEE,
    COLUMN_OWNER,
    COLUMN_UPDATED_DATE,
    COLUMN_CREATED_BY,
    COLUMN_CREATED_DATE,
  ]),
  collapsed: array(string()).default([]),
});
